<template>
  <b-container :style="footerStyle">
    <b-row>
      <b-col cols="12" md="auto" class="mb-3 mb-sm-0 footer-address">
        <div class="footer-company">© {{ $t('footer.name_company') }}</div>

        <div class="footer-address-details">
          <div class="footer-address-line">
            <span class="address-first-part">{{ $t('footer.address_1') }}</span
            ><br class="address-br" />
            <span v-for="(part, i) in addressParts" :key="i" class="address-chunk">{{ part }}</span>
          </div>
        </div>
      </b-col>
      <b-col>
        <ul class="list-inline mb-0 text-left text-md-right ml-3">
          <li class="list-inline-item">
            <b-link :to="{ name: 'Terms' }" style="font-size: 16px"
              >{{ $t('footer.terms_of_use') }}
            </b-link>
          </li>
          <li class="list-inline-item">
            <b-link :to="{ name: 'PrivacyAndPolicy' }" style="font-size: 16px"
              >• {{ $t('footer.privacy_policy') }}</b-link
            >
          </li>
          <li class="list-inline-item">
            <b-link :to="{ name: 'UserDataDeletionInstructions' }" style="font-size: 16px"
              >• {{ $t('footer.user_deletion') }}</b-link
            >
          </li>
        </ul>
        <div class="d-none d-sm-block">
          <div class="d-flex flex-row-reverse">
            <div class="p-2">
              <span> <a href="https://line.me/R/ti/p/@bluuu" target="_blank">@bluuu</a></span>
              <br />
              <div v-if="isShowTelephone">
                <span> <a href="tel:020556768">020556768</a></span
                ><br />
              </div>
              <span> info@bluuu.co</span><br />
            </div>
            <div class="p-2">
              <a href="https://line.me/R/ti/p/@bluuu" target="_blank"
                ><img alt="line" src="../assets/images/icons/line.png" /></a
              ><br />
              <div v-if="isShowTelephone">
                <a href="tel:020556768"
                  ><img alt="phone" src="../assets/images/icons/phone.png" /></a
                ><br />
              </div>
              <img alt="email" src="../assets/images/icons/email.png" /><br />
            </div>
            <div class="p-2 text-end">
              {{ $t('footer.contact_us') }}
              <div>{{ $t('footer.available_tme') }}</div>
            </div>
          </div>
        </div>
        <div class="d-block d-sm-none ml-3">
          <div class="d-flex flex-row">
            <div class="py-2">{{ $t('footer.contact_us') }}</div>
            <div class="p-2">
              <div>&nbsp;</div>
              <a href="https://line.me/R/ti/p/@bluuu"
                ><img alt="line" src="../assets/images/icons/line.png" /></a
              ><br />
              <div v-if="isShowTelephone">
                <a href="tel:020556768"
                  ><img alt="phone" src="../assets/images/icons/phone.png" /></a
                ><br />
              </div>
              <img alt="email" src="../assets/images/icons/email.png" /><br />
            </div>
            <div class="p-2">
              <div class="no-icon">{{ $t('footer.available_tme') }}</div>
              <span> <a href="https://line.me/R/ti/p/@bluuu">@bluuu</a></span
              ><br />
              <div v-if="isShowTelephone">
                <span> <a href="tel:020556768">020556768</a></span
                ><br />
              </div>
              <span> info@bluuu.co</span><br />
            </div>
          </div>
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="12">
        <div class="text-timestamp">{{ timezone }} {{ isBKKtime ? '/' : '' }}</div>
      </b-col>
    </b-row>
    <BaseModal size="lg" id="service-policy-modal" :scrollable="true">
      <ServicesContent v-if="showScopeServiceContent" />
      <PrivacyPolicyContent v-if="showPolicyContent" />
      <TermsAndConditionContent v-if="showToSContent" />
    </BaseModal>
  </b-container>
</template>

<script>
import Vue from 'vue'
import { Component } from 'vue-property-decorator'
import { debounce } from 'lodash'
import BaseModal from '../components/Modal/BaseModal'
import ServicesContent from '../components/Modal/ServicesContent'
import TermsAndConditionContent from '../components/Modal/TermsAndConditionContent'
import PrivacyPolicyContent from '../components/Modal/PrivacyPolicyContent'

@Component({
  components: {
    BaseModal,
    ServicesContent,
    TermsAndConditionContent,
    PrivacyPolicyContent,
  },
})
export default class Footer extends Vue {
  contentType = ''
  telephone_hidden_start_date = new Date('Oct 9 2022 08:00:00 GMT+0700 (Indochina Time)')
  telephone_hidden_end_date = new Date('Oct 20 2022 08:00:00 GMT+0700 (Indochina Time)')
  timezone = new Date().toString()
  isBKKtime = false
  screenWidth = window.innerWidth
  interval = null

  created() {
    this.handleResize = debounce(this.handleResize, 150)
  }

  openModal(type) {
    this.contentType = type
    this.$root.$emit('bv::show::modal', 'service-policy-modal')
  }

  get footerStyle() {
    const isMobile = this.screenWidth < 767.98
    return this.$route.name === 'BookingReview' && isMobile
      ? {
          marginTop: '-150px',
          backgroundColor: '#4a556a',
          paddingTop: '20px',
          zIndex: '1000',
          position: 'relative',
        }
      : {}
  }

  get isShowTelephone() {
    const date = new Date(new Date().toLocaleString('en', { timezone: 'Asia/Bangkok' }))
    return date < this.telephone_hidden_start_date || date > this.telephone_hidden_end_date
  }

  get showScopeServiceContent() {
    return this.contentType === 'scope-of-service'
  }

  get showPolicyContent() {
    return this.contentType === 'policies'
  }

  get showToSContent() {
    return this.contentType === 'terms-condition'
  }

  get addressParts() {
    const msgs = this.$i18n.getLocaleMessage(this.$i18n.locale) || {}
    const parts = (msgs.footer && msgs.footer.address_parts) || []
    return parts.map((p) =>
      p
        .replace(/[\u200B-\u200D\uFEFF]/g, '')
        .replace(/^(แขวง|เขต)\s+/, '$1')
        .trim()
    )
  }

  checkTimeCurrent() {
    const current_date = localStorage.getItem('currentDate') || new Date()
    const currentTime = new Date().getTime()
    const dateThreshold = 1000 * 60 * 60 // 1 hour in milliseconds
    const wrong_current_date =
      current_date && Math.abs(new Date(current_date).getTime() - currentTime) > dateThreshold
    return !wrong_current_date
  }

  mounted() {
    this.timezone = new Date().toString()
    this.isBKKtime = this.checkTimeCurrent()
    this.interval = setInterval(() => {
      this.timezone = new Date().toString()
      this.isBKKtime = this.checkTimeCurrent()
    }, 1000)
    window.addEventListener('resize', this.handleResize)
  }

  beforeDestroy() {
    clearInterval(this.interval)
    window.removeEventListener('resize', this.handleResize)
  }

  handleResize() {
    this.screenWidth = window.innerWidth
  }
}
</script>
<style lang="scss" scoped>
.text-timestamp {
  font-size: 10px;
  margin-top: 0;
  color: #4a556a;
}

.no-icon {
  margin-left: -38px;
}

.text-end {
  text-align: end;
}

.footer-address {
  min-width: 0;
  max-width: 100%;
  box-sizing: border-box;
}

.footer-company {
  padding: 0;
  margin: 0;
  text-indent: 0;
}

.footer-address-details {
  padding-left: 1rem;
  min-width: 0;
  max-width: 100%;
  box-sizing: border-box;
  line-height: 1.5;
}

.footer-address-line {
  display: block;
  white-space: normal;
}

.address-chunk {
  display: inline-block;
  white-space: nowrap;
  word-break: keep-all;
  margin-right: 0.3em;
}

.address-first-part {
  margin-right: 0.3em;
}

.address-br {
  display: none;
}

@media screen and (min-width: 768px) {
  .address-br {
    display: block;
  }
  .address-first-part {
    margin-right: 0;
    white-space: nowrap;
  }
}
</style>
